/**
 * List template render API resource
 * Endpoint: /api/easyblocks/classes/ListTemplateService.php
 */

import { getApiBaseUrl, joinUrl } from "./client";
import type { ListTemplateRenderParams, ListTemplateRenderResponse } from "./types";

/**
 * POST /api/easyblocks/classes/ListTemplateService.php
 * Render a KD list template to HTML
 */
export async function renderListTemplate(
  params: ListTemplateRenderParams
): Promise<ListTemplateRenderResponse> {
  const endpoint = new URL(joinUrl(getApiBaseUrl(), "classes/ListTemplateService.php"), window.location.origin);
  const pageSearch = typeof params.pageSearch === "string" ? params.pageSearch.trim() : "";
  if (pageSearch) {
    endpoint.search = pageSearch.startsWith("?") ? pageSearch : `?${pageSearch}`;
  }
  if (params.page_item_id !== undefined && params.page_item_id !== null && String(params.page_item_id).trim() !== "") {
    endpoint.searchParams.set("page_id", String(params.page_item_id));
  }
  const fd = new FormData();
  fd.append("KD_list_tpl_item_name", params.KD_list_tpl_item_name);

  const res = await fetch(endpoint.toString(), {
    method: "POST",
    body: fd,
    credentials: "same-origin",
    headers: { Accept: "application/json" },
  });

  if (!res.ok) {
    const text = await res.text();
    throw new Error(`List template render failed (${res.status} ${res.statusText}): ${text}`);
  }

  return (await res.json()) as ListTemplateRenderResponse;
}
